// reducers/auth/auth.js

// --- ALL ---

export function token(state = false, action) {
  switch (action.type) {
    case 'REFRESHING_TOKEN':
      return action.freshTokenPromise;
    default:
      return state;
  }
}